import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceService } from 'src/app/servicios/service.service';
import { ConsultasService } from 'src/app/servicios/consultas.service';
import { Loading } from 'src/app/Class/Loading';
import { DTConfig } from 'src/app/Class/DTConfig ';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-suscritos',
  templateUrl: './suscritos.component.html',
  styleUrls: ['./suscritos.component.css']
})
export class SuscritosComponent implements OnInit {

  public suscritos: any = [];
  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  public dtOptions: DataTables.Settings = DTConfig.dtConf;
  public dtTrigger: Subject<any> = new Subject();

  constructor(private consultaService: ConsultasService, private servi: ServiceService,  public loading: Loading) {
    this.loading.estado = true;
    this.consultaService.getListadoSuscritos()
      .subscribe(data => { this.suscritos = data; 
                          this.loading.estado = false;
                          this.rerender();
      }); 
   }

  ngOnInit() {
  }


  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
